// Every page's content sits in one centred column on wide screens (Craig, 30 Oct 2026: Radar stretched the full
// width while the other pages didn't). The top bar and full-width bands still span the screen.
export const PAGE_WIDTH = 680;

// A block whose children sit in the column.
export const pageColumn = { maxWidth: PAGE_WIDTH, margin: "0 auto" };

// Side padding for a full-width scroll area or band: `side` px on a phone, and on a wide screen enough to keep its
// content in the column, so the scroll bar stays at the screen's edge. The content is as wide as a `pageColumn` block
// with 20px padding (Tasks, Goals) whatever `side` is, so Chat's 16px doesn't move its edge. Percentages in padding are
// of the parent's width.
const COLUMN_GUTTER = 20;
export const columnPadding = (side = COLUMN_GUTTER) => `max(${side}px, calc(50% - ${PAGE_WIDTH / 2 - COLUMN_GUTTER}px))`;

// From a tablet held sideways up, the app fills the screen with a sidebar on the left in place of the bottom bar
// (Craig, 4 Nov 2026: "go back to the app spanning the full width of the screen… implement a left side bar on larger
// screens instead of the bottom navbar"; the 760px frame of 2 Nov 2026 is gone). Below SIDEBAR_MIN nothing changes.
export const SIDEBAR_MIN = 900;
export const SIDEBAR_WIDTH = 248;
// Folded to its icons (Craig, 4 Nov 2026); kept in settings as `sidebarFolded`.
export const SIDEBAR_FOLDED_WIDTH = 64;
// The top bar's height; the sidebar's header matches it so the lines under them meet.
export const TOP_BAR_HEIGHT = 58;
// From a laptop up, a page with two parts can show them side by side (Craig, 2 Nov 2026: "on the today page, we could
// have two major columns"). The window must leave each column, beside the sidebar, 420px or more: narrower and Today's
// Plan heading wraps beside its Radar button. A sideways iPad (1024px) keeps one column.
const COLUMN_MIN = 420, COLUMN_GAP = 32, COLUMNS_PAD = 32;
export const TWO_COLUMN_MIN = SIDEBAR_WIDTH + 2 * COLUMN_MIN + COLUMN_GAP + 2 * COLUMNS_PAD;
// Home's square tiles: three a row beside the sidebar, four once the window has room for four full-size ones.
export const HOME_TILE_MAX = 180;
export const HOME_FOUR_MIN = 1080;
// How wide two columns grow, so they don't drift apart on a big monitor.
export const WIDE_PAGE_WIDTH = 1040;

// The two-column rules, drawn once by NudgeApp's style block. A page splits by putting `page-columns-scroll` on its
// scroll area and `page-columns` on a block of two children. Today's `plan-head` puts "Today's Plan" beside its Radar
// button there. `hover` is the sidebar's row colour under the pointer.
// The sidebar's rows are 44px for a finger and 36px under a mouse, so the whole list fits a laptop's height. Hover
// shows only where there's a pointer to hover with, so it doesn't stick after a tap on an iPad.
export const wideCss = (hover) => `
  @media (hover: hover) { .side-item:not([aria-current]):hover, .side-icon:not([aria-current]):hover > span { background: ${hover} !important; } }
  @media (pointer: fine) { .side-item { min-height: 36px !important; } }
  @media (min-width: ${HOME_FOUR_MIN}px) { .home-grid { grid-template-columns: repeat(4, minmax(0, 1fr)) !important; max-width: ${4 * HOME_TILE_MAX + 3 * 14 + 64}px !important; } }
  @media (min-width: ${TWO_COLUMN_MIN}px) {
    .page-columns-scroll { padding-left: max(${COLUMNS_PAD}px, calc(50% - ${WIDE_PAGE_WIDTH / 2}px)) !important; padding-right: max(${COLUMNS_PAD}px, calc(50% - ${WIDE_PAGE_WIDTH / 2}px)) !important; }
    .page-columns { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: ${COLUMN_GAP}px; align-items: start; }
    .plan-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 23px; }
    .plan-head > * { margin: 0 !important; }
  }
`;
